import {useQuery} from '@apollo/react-hooks';

import {safelyGetGraphQLErrorMessage} from 'nutshell-core/utils/graphql-errors';

import type {
    GetIndustries_industries as Industry,
    GetIndustries as GetIndustriesQuery,
} from 'nutshell-graphql-types';

import GET_INDUSTRIES from '../queries/get-industries.graphql';

export const useGetIndustries = (): {
    isLoading: boolean;
    errorMessage: string | null | undefined;
    industries: Industry[];
} => {
    const {loading, data, error} = useQuery<GetIndustriesQuery, Record<any, any>>(GET_INDUSTRIES, {
        fetchPolicy: 'cache-and-network',
        notifyOnNetworkStatusChange: true,
    });

    return {
        isLoading: loading,
        // @ts-expect-error
        errorMessage: safelyGetGraphQLErrorMessage(error),
        industries: data && data.industries ? data.industries : [],
    };
};
